import { NgModule } from '@angular/core';
import { AmdDialogComponent } from './dialog.component';
export class AmdDialogModule {
}
AmdDialogModule.decorators = [
    { type: NgModule, args: [{
                exports: [AmdDialogComponent],
                declarations: [AmdDialogComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdDialogModule.ctorParameters = () => [];
function AmdDialogModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDialogModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDialogModule.ctorParameters;
}
//# sourceMappingURL=dialog.module.js.map
//# sourceMappingURL=dialog.module.js.map
